// extracted by mini-css-extract-plugin
export var callCard = "_lr-0";
export var callMessageButton = "_lr-1";
export var helpIcon = "_lr-3";
export var helpIconContainer = "_lr-4";
export var verticalDivider = "_lr-2";